module.exports = __webpack_public_path__ + "img/top_images@3x.d7f075f9.png";